import type { ChangeEvent } from 'react'
import React from 'react'
import { useIntl } from 'react-intl'
import TextInput from '../TextInput/TextInput'
import { ActionTypes } from './Actions'
import { useTable } from './Table'

interface SearchProps {
  defaultValue?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

function Search({ defaultValue = '', onChange }: SearchProps): JSX.Element {
  const intl = useIntl()
  const [, dispatch] = useTable()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: ActionTypes.FirstPage })
    onChange?.(event)
  }

  return (
    <div className="ml-auto">
      <TextInput
        defaultValue={defaultValue}
        label={intl.formatMessage({ id: 'Table.search' })}
        onChange={handleChange}
        size="small"
        type="search"
      />
    </div>
  )
}

export default Search
